export default __webpack_public_path__ + "static/media/logo.562c0949.jpg";